import 'lazysizes';
import $ from 'jquery';

import Alpine from 'alpinejs';
import checkFaders from './components/animations.js';
import header from './components/header.js';
import gallery from './components/gallery.js';

Alpine.data('header', header);
Alpine.data('gallery', gallery);
Alpine.start();

$(function() {
  checkFaders();
  window.addEventListener('scroll', checkFaders);
  window.addEventListener('resize', checkFaders);
});